export class QuotaHistory {
    public date: string;
    public usage: number;
    public limit: number;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.date = json.date;
            this.usage = json.usage;
            this.limit = json.limit;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/quotaHistory.ts